import { Scoreboard } from '../ui/Scoreboard';
import { RoomInfo } from '../ui/RoomInfo';
import { MuteButton } from '../ui/MuteButton';
import { soundManager } from '../audio/SoundManager';
import { eventBus } from '../events/EventBus';
import { Debug, LogCategory } from '../../../shared/Debug';
import { Instructions } from '../ui/Instructions';

const TeamAName = 'Home';
const TeamBName = 'Away';

/**
 * Manages UI elements and their interactions
 */
export class UIManager {
  private scoreboard: Scoreboard | null = null;
  private roomInfo: RoomInfo | null = null;
  private muteButton: MuteButton | null = null;
  private instructions: Instructions | null = null;
  constructor() {
    // Set up event listeners
    this.initializeEventListeners();
  }

  private initializeEventListeners(): void {
    // Listen for game events
    eventBus.subscribe('game:started', () => {
      if (this.scoreboard) {
        this.scoreboard.startGame();
      }
      soundManager.play('whistle');

    });
    
    eventBus.subscribe('game:paused', () => {
        /*
        // TODO: fix this
      if (this.scoreboard) {
        this.scoreboard.pauseGame();
      }
      soundManager.stopLoop('crowd');
      */
    });
    
    eventBus.subscribe('game:over', (data: { homeScore: number, awayScore: number }) => {
      if (this.scoreboard) {
        // Ensure the final scores are set before showing game over screen
        this.scoreboard.updateScore(data.homeScore, data.awayScore);
        this.scoreboard.handleGameOver();
      }

      soundManager.play('celebration');
    });
    
    eventBus.subscribe('game:basket', (data: { rim: string }) => {
      // Play swish sound immediately when basket is scored
      soundManager.play('swish');

      // Play a random cheer sound effect
      const cheerNumber = Math.floor(Math.random() * 5) + 1;
      const cheerSound = `cheer${cheerNumber}` as keyof typeof soundManager.SOUND_PATHS;
      soundManager.play(cheerSound, 0.7);
      
      
      // Trigger net animation based on which rim was scored on
      eventBus.publish('court:trigger-net', { basketId: data.rim });
    });
  }

  /**
   * Initialize UI elements
   */
  public initialize(): void {
    // Create the scoreboard UI
    this.scoreboard = new Scoreboard(TeamAName, TeamBName);
    
    // Create the Room ID display
    this.roomInfo = new RoomInfo();
    
    // Create mute button
    this.muteButton = new MuteButton();


    // Create instructions
    this.instructions = new Instructions();
    
    Debug.info('UI manager initialized', LogCategory.GENERAL);
  }

  /**
   * Update the scoreboard with latest scores
   */
  public updateScoreboard(homeScore: number, awayScore: number): void {
    if (!this.scoreboard) return;
    
    // Update the scoreboard
    this.scoreboard.updateScore(homeScore, awayScore);
    
  }

  /**
   * Update the displayed room ID
   */
  public updateRoomId(roomId: string | null): void {
    if (this.roomInfo) {
      this.roomInfo.updateRoomId(roomId);
    }
  }

  /**
   * Update UI state based on game state
   */
  public updateFromGameState(state: any): void {
    if (!state) return;
    
    // Update score
    if (state.homeScore !== undefined && state.awayScore !== undefined && this.scoreboard) {
      this.updateScoreboard(state.homeScore, state.awayScore);
    }
    
    // Update game state
    if (state.gameStarted !== undefined && this.scoreboard) {
      if (state.gameStarted && !this.scoreboard.getGameActive()) {
        this.scoreboard.startGame();
      } else if (!state.gameStarted && this.scoreboard.getGameActive()) {
        this.scoreboard.pauseGame();
      }
    }
  }

  /**
   * Cleanup resources
   */
  public dispose(): void {
    // Cleanup UI elements
    if (this.scoreboard) {
      this.scoreboard = null;
    }
    
    if (this.roomInfo) {
      this.roomInfo = null;
    }
    
    if (this.muteButton) {
      this.muteButton = null;
    }
  }
}